import { Component, OnInit } from '@angular/core';
import {FormGroup, FormBuilder, FormArray} from '@angular/forms';

@Component({
    selector: 'app-accessorials-rates-edit',
    templateUrl: './accessorials-rates-edit.component.html',
    styleUrls: ['./accessorials-rates-edit.component.css'],
    standalone: false
})
export class AccessorialsRatesEditComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
